module.exports = __webpack_public_path__ + "static/media/to.79354e72.svg";